// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"po_a bie_sn bie_sv bie_sw bie_kx bie_ky bie_ke undefined bie_vt"};